"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseSchema = exports.DistributorSchema = exports.PartnerSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
exports.PartnerSchema = base_1.BaseSchema.extend({
    storeId: base_1.ShortStringSchema.uuid(),
    licensesAvailable: zod_1.z.number().int().nonnegative(),
    licensesRedeemed: zod_1.z.number().int().nonnegative().optional(),
    licensesPreferences: zod_1.z.object({
        mustCloneItems: zod_1.z.boolean(),
    }),
    planId: base_1.ShortStringSchema.uuid().optional(),
    countryCode: zod_1.z.nativeEnum(base_1.Alpha3Countries),
    backgroundImageUri: base_1.ShortStringSchema.url().optional(),
    logoUri: base_1.ShortStringSchema.url().optional(),
    secondaryLogoUri: base_1.ShortStringSchema.url().optional(),
    slogan: base_1.ShortStringSchema.optional(),
    name: base_1.ShortStringSchema,
});
exports.DistributorSchema = base_1.BaseSchema.extend({
    partnerId: base_1.ShortStringSchema.uuid(),
    licensesAvailable: zod_1.z.number().int().nonnegative(),
    licensesRedeemed: zod_1.z.number().int().nonnegative(),
    skus: zod_1.z.array(base_1.ShortStringSchema),
    region: base_1.ShortStringSchema.optional(),
    contactEmail: base_1.ShortStringSchema.email().optional(),
    contactPhoneNumber: base_1.PhoneSchema.optional(),
});
exports.LicenseSchema = base_1.BaseSchema.extend({
    partner: exports.PartnerSchema.partial().required({
        id: true,
    }),
    distributor: exports.DistributorSchema.partial()
        .required({
        id: true,
    })
        .optional(),
    email: base_1.ShortStringSchema.email(),
    storeId: base_1.ShortStringSchema.uuid().optional(),
    redeemedAt: zod_1.z.coerce.date().optional(),
});
__exportStar(require("./terms-and-conditions"), exports);
//# sourceMappingURL=index.js.map